export default ($axios) => (resource) => ({
  index() {
    return $axios.get(`${resource}`);
  },

  stepstatus(payload) {
    return $axios.post(`${resource}`, payload);
  },
});
